import * as _ from "lodash";
import * as React from "react";
import { Dropdown } from "semantic-ui-react";
import OrganizationsBase, {
  IOrganizationsBaseProps,
  IOrganizationsBaseState,
} from "../Organizations/OrganizationsBase";
import * as routes from "../../constants/routes";
import { InviteUserModel } from "../Organizations/InviteUsersModel";
import { firebaselogin } from "src/firebase/firebaselogin";
export interface IOrganizationsNavState extends IOrganizationsBaseState {
  openInviteUserModel: boolean;
}
export default class OrganizationsNav extends OrganizationsBase<
  IOrganizationsBaseProps,
  IOrganizationsNavState
> {
  constructor(props: IOrganizationsBaseProps) {
    super(props);
    this.state = {
      ...OrganizationsBase.INITIAL_STATE,
      openInviteUserModel: false,
    };
  }
  private handleInviteModelSetOpen = (open: boolean) => {
    this.setState({ openInviteUserModel: open });
  };

  public render() {
    const { orgs, openInviteUserModel, currentOrg } = this.state;
    const { authUser, roles, history } = this.props;
    const exceptCurrentOrg = _.filter(orgs, (o) => o.id !== currentOrg.id);
    return (
      currentOrg && (
        <React.Fragment>
          <InviteUserModel
            authUser={authUser}
            currentOrg={currentOrg}
            open={openInviteUserModel}
            setOpen={this.handleInviteModelSetOpen}
          />
          <Dropdown item={true} icon="bars" text={currentOrg.name}>
            <Dropdown.Menu className="settings_menu">
              {roles && (roles.admin || roles.owner) && (
                <React.Fragment>
                  <Dropdown.Item
                    text={`Invite people to ${currentOrg.name}`}
                    onClick={() => {
                      this.handleInviteModelSetOpen(true);
                    }}
                  />
                  <Dropdown item={true} simple={true} text="Administration">
                    <Dropdown.Menu>
                      <Dropdown.Item
                        text="Manage Users"
                        onClick={() =>
                          history.push(routes.MANAGE_USERS(currentOrg.id))
                        }
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </React.Fragment>
              )}

              <Dropdown item={true} simple={true} text="Organizations">
                <Dropdown.Menu>
                  {exceptCurrentOrg.map((option: any) => (
                    <Dropdown.Item
                      key={option.id}
                      text={`Sign in to ${option.name}`}
                      onClick={() => this.handleOrgClicked(option.id)}
                    />
                  ))}

                  <Dropdown.Item
                    text="Create new organization"
                    onClick={() => history.push(routes.ORGANIZATIONS)}
                  />
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown.Divider />
              <Dropdown.Item
                text="Sign out"
                onClick={() => firebaselogin.auth().signOut()}
              />
            </Dropdown.Menu>
          </Dropdown>
          {/* <Dropdown.Item
                text="Create New"
                onClick={this.handleNewAnalysisClicked}
              />
            <Dropdown.Divider />
            <Input icon="search" iconPosition="left" className="search" /> */}
        </React.Fragment>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/OrganizationsNav.tsx